
<!--地球操作MainGlobeOperation混入方法：影像中心标记创作文件相关-->

<script>
import * as turf from "@turf/turf";
import html2canvas from "html2canvas";

export default {
  name: "MainGlobeOperationFolder",
  data(){
    return{

      // currFolderId:"",   //当前打开的文件id
      // currFolderName:"",
      // currFolderPublicStatus:"",


      //创建文件夹
      createFolderShow:false,

      //编辑文件名称
      editFolderNameShow:false,
      oldFolderName:"",


      //选择打开/导入文件
      chooseFolderShow:false,

      // 图层导入弹窗显隐
      importLayerDialogShow: false,

      //另存为文件夹
      resaveFolderShow:false,


      //导出
      exportFolderShow:false,



      // //样例数据
      // exampleShow:true,
      // exampleList:[],
      exampleDialogShow:false,

        //团队成员弹窗
        memberListDialogShow:false,
        inviteCode:'',
        inviteMemberDialogShow:false,




    }

  },
  methods:{



    //进入时初始化文件信息
    initFolderInfo(){
      this.$axios.get('/authorApi/z-geo-file/getRecentlyFileId')
          .then((resultData)=>{
            resultData = resultData.data;
            if(resultData.status === 200){
              if(resultData.data !== ""){
                //打开该文件夹
                this.openFolderById(resultData.data)
                this.$store.state.globeQuitShowDialog = false;
              }
              else{
                //该用户没有上次打开的文件夹，新建默认文件夹
                this.$axios({
                  method:"post",
                  url:"/authorApi/z-geo-file/newFile",
                  params:{
                    fileName:"实验室默认创作"
                  }
                }).then((resultData_newFile)=>{
                  resultData_newFile = resultData_newFile.data;
                  if(resultData_newFile.status === 200){
                    this.openFolderById(resultData_newFile.data)
                    this.$store.state.globeQuitShowDialog = false;
                  }
                  else{
                  //  console.log(resultData_newFile.status + resultData_newFile.message);
                  }
                }).catch(()=>{
                 // console.log(err);
                });

              }

            }
            else{
             // console.log(resultData.status + resultData.message);
            }
          })
          .catch(()=>{

          })
    },


    //更多操作-地图设置
    openGlobeSet(){
      this.$emit("openGlobeSet","")
    },


    //新建文件夹 成功
    createFolderOk(folderId){
      //打开该文件夹
      this.openFolderById(folderId)
      this.createFolderShow = false;
      this.$store.state.globeQuitShowDialog = false;
    },


    //进入编辑文件夹名称
    intoEditFolderName(e){
      this.editFolderNameShow = true;
      this.oldFolderName = this.$store.state.currFolderName
        this.$store.state.currFolderName = this.$store.state.currFolderName+ ' '
        //该双击场景名称的下一个元素，是输入框
      let currTextFieldDom = e.target.nextSibling.querySelector("textarea")
      setTimeout(()=>{
        currTextFieldDom.focus()
        currTextFieldDom.select();
      },0)
    },

    editFolderNameOk(){
      if(this.$store.state.currFolderName.trim().length > 30){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "文件名超出30字"
        this.$store.state.snackbarType = 'error'

        this.$store.state.currFolderName = this.oldFolderName
      }
      else if(this.$store.state.currFolderName.trim().length === 0){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "文件名不能为空"
        this.$store.state.snackbarType = 'error'

        this.$store.state.currFolderName = this.oldFolderName
      }
      else{
        this.$axios.get('/authorApi/z-geo-file/rename',{
          params:{
            'fileId':this.$store.state.currFolderId,
            'fileName':this.$store.state.currFolderName,
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          if(resultData.status === 200){
            this.editFolderNameShow = false;
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "文件名修改成功"
              this.$store.state.snackbarType = 'success'
          }
          else if(resultData.status === 308){
            this.$store.state.currFolderName = this.oldFolderName
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = "已存在同名文件"
            this.$store.state.snackbarType = 'error'

          }
          else{
          // console.log(resultData.status + resultData.message);
          }
        }).catch(()=>{

        })
      }

    },


    //选择打开导入文件，确定
    chooseFolderOk(folderId){
      this.chooseFolderShow = false;

        this.$store.state.selectLayerTreeNode = ''
      this.openFolderById(folderId)
    },

    //选择导入文件，导入完成
    chooseFolderUploadFileOk(uploadFileData){
      //深度遍历补充长度和面积 属性
      let getLengthAndAreaFile = JSON.parse(uploadFileData)
      this.chooseFolderGetLengthAndArea(getLengthAndAreaFile)

      // //计算过长度和面积之后的导入文件
      // let chooseFileData = JSON.parse(uploadFileData)
      // chooseFileData.children = getLengthAndAreaFile

        this.$axios({
            method:"post",
            url:"/authorApi/z-geo-file/fileImport2",
            data:{
                fileId:this.$store.state.currFolderId,
                content:getLengthAndAreaFile,
            }
        }).then((res)=>{
            if(res.data.status === 200){
              //  this.$store.state.globeOperationMarkerList = this.$store.state.globeOperationMarkerList.concat(res.data.data)
                this.$store.state.globeOperationMarkerList.push.apply(this.$store.state.globeOperationMarkerList,res.data.data)
                this.$emit('initMapMarker',this.$store.state.globeOperationMarkerList)
                this.chooseFolderShow = false;
            }else{
                this.$store.state.snackbarShow=true
                this.$store.state.snackbarText = "上传错误"
                this.$store.state.snackbarType = 'error'
            }
        }).catch(()=>{
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = "上传错误"
            this.$store.state.snackbarType = 'error'
        })

    },
    //为选择导入的数据补充周长和面积
    chooseFolderGetLengthAndArea(treeList) {
      //深度遍历 turf计算长度 面积
      //分类型 lineString  polygon
      for(let i=0;i<treeList.length;i++){
        if(treeList[i].type === "folder" && treeList[i].children &&  treeList[i].children.length>0){
          //是目录 同时有孩子
          this.chooseFolderGetLengthAndArea(treeList[i].children)
        }
        else if(treeList[i].type !== "folder"){
          //是标记
          if(treeList[i].type === "lineString"){
            if(treeList[i].geoJson.geo.geometry.type === "MultiLineString"){
              let len = 0;
              for(let j=0;j<treeList[i].geoJson.geo.geometry.coordinates.length;j++){
                len = len + turf.length(turf.lineString(treeList[i].geoJson.geo.geometry.coordinates[j]),{units: 'kilometers'})
              }
              treeList[i].geoJson.geo.properties.len = len * 1000
            }
            else if(treeList[i].geoJson.geo.geometry.type === "LineString"){
              treeList[i].geoJson.geo.properties.len = turf.length(turf.lineString(treeList[i].geoJson.geo.geometry.coordinates),{units: 'kilometers'}) * 1000
            }
          }

          else if(treeList[i].type === "polygon"){
            if(treeList[i].geoJson.geo.geometry.type === "MultiPolygon"){
              let area = 0;
              let len = 0;
              for(let j=0;j<treeList[i].geoJson.geo.geometry.coordinates.length;j++){
                len = len + turf.length(turf.lineString(treeList[i].geoJson.geo.geometry.coordinates[j][0]),{units: 'kilometers'}) * 1000
                area = area + turf.area(turf.polygon(treeList[i].geoJson.geo.geometry.coordinates[j]))
              }
              treeList[i].geoJson.geo.properties.len = len
              treeList[i].geoJson.geo.properties.area = area
            }
            else if(treeList[i].geoJson.geo.geometry.type === "Polygon"){
              treeList[i].geoJson.geo.properties.len = turf.length(turf.lineString(treeList[i].geoJson.geo.geometry.coordinates[0]),{units: 'kilometers'}) * 1000
              treeList[i].geoJson.geo.properties.area = turf.area(turf.polygon(treeList[i].geoJson.geo.geometry.coordinates))
            }

          }

        }
        else{
          //是目录，但是没有孩子

        }
      }

    },


    //选择导入文件，类型错误
    chooseFolderUploadFileError(){
      this.$store.state.snackbarShow=true
      this.$store.state.snackbarText = "请选择正确数据类型"
      this.$store.state.snackbarType = 'error'

    },

    importLayerOk(info) {
      this.importLayerDialogShow = false
      this.$store.state.snackbarShow=true
      this.$store.state.snackbarText = "图层导入成功"
      this.$store.state.snackbarType = 'success'
      this.getSatelliteLayerList(this.$store.state.currFolderId)
    },
    importLayerFail() {
      this.importLayerDialogShow = false
    },



    //另存为文件夹
    resaveFolderOk(folderId){
      this.openFolderById(folderId)
      this.resaveFolderShow = false;
      this.$store.state.snackbarShow=true
      this.$store.state.snackbarText = "文件已保存"
      this.$store.state.snackbarType = 'success'

    },
    resaveFolderFailed(){
        this.resaveFolderShow = false;
    },
    //获取邀请信息
    getInviteDialog(){
        this.$axios.get('/authorApi/z-geo-team/getInvitedInfo',{
            params:{
                inviteCode:this.inviteCode
            }
        }).then((res)=>{
            if(res.data.status === 200){
                //已经加入了
                if(res.data.data.isJoined){
                    if(window.localStorage.getItem('inviteCode'))
                        window.localStorage.removeItem('inviteCode');
                    this.inviteIntoTeamOk(res.data.data.fileId)
                }else{
                    this.inviteMemberDialogShow = true
                }
            }else{
                if(window.localStorage.getItem('inviteCode'))
                    window.localStorage.removeItem('inviteCode');
                this.$store.state.snackbarShow=true
                this.$store.state.snackbarText = "邀请链接已失效！"
                this.$store.state.snackbarType = 'error'
            }
        })
    },

    //打开某文件
    openFolderById(folderId){
      //清除掉选择的图层
      this.$store.state.showSatelliteLayerList = []
      this.$store.state.showVizLayerList = []
      this.$store.state.satelliteLayerList = []
      this.$store.state.dataVizLayerList = []

      this.$store.state.selectLayerTreeNode = ''
      this.getFolderDataList(folderId)
      this.getDataVizLayerList(folderId)
      this.getSatelliteLayerList(folderId)
    },

    getFolderDataList(folderId){
        this.$axios.get('/authorApi/z-geo-file/openFile',{
          params:{
              'fileId':folderId
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          if(resultData.status === 200){
            this.$store.state.currFolderId = folderId
            this.$store.state.currFolderName = resultData.data.fileName
            this.$store.state.currFolderPublicStatus = resultData.data.publicStatus
            this.$store.state.globeOperationMarkerList = resultData.data.content
            //文件类型以及团队文件权限
            this.$store.state.currFolderMember = resultData.data.teamList
            this.$store.state.currFolderType = resultData.data.authority // 1团队，0个人
            this.$store.state.currFolderTeamExport = resultData.data.teamExport
            this.$store.state.currFolderTeamInvite = resultData.data.teamInvite
            this.$store.state.currFolderTeamReadonly = resultData.data.teamReadonly
            this.$store.state.currFolderTeamSave = resultData.data.teamSave
            this.$store.state.currFolderMembersNumber = resultData.data.teamMembersNumber
            this.$store.state.currFolderRole = resultData.data.role
            this.$emit('initMapMarker',resultData.data.content)
            //取消选中
            this.cancelSelect()
          }
          else{
            // console.log(resultData.status + resultData.message);
          }
        }).catch(()=>{})
      },
    getDataVizLayerList(folderId){
      this.$axios.get('/authorApi/z-geo-file/openFileLayer2',{
        params:{
          'fileId':folderId
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.$store.state.dataVizLayerList = resultData.data
          for (let i = 0; i < this.$store.state.dataVizLayerList.length; i++) {
            let layer = this.$store.state.dataVizLayerList[i]
            layer.show = false
          }
        }
      }).catch(()=>{})
    },
    getSatelliteLayerList(folderId) {
      this.$axios.get('/authorApi/z-geo-file-layer/getZGeoFileLayerList',{
        params:{
          'fileId':folderId
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.$store.state.satelliteLayerList = resultData.data
          for (let i = 0; i < this.$store.state.satelliteLayerList.length; i++) {
            let layer = this.$store.state.satelliteLayerList[i]
            layer.show = false
          }
        }
      }).catch(()=>{})
    },

    //导出成功
    exportFolderOk(fileDownloadUrl){

      this.$store.state.snackbarShow=true
      this.$store.state.snackbarText = "文件已导出"
      this.$store.state.snackbarType = 'success'

      let fileDownloadUrlList = JSON.parse(fileDownloadUrl)

      for(let i=0;i<fileDownloadUrlList.length;i++){
        const iframe = document.createElement("iframe");
        iframe.style.display = "none"; // 防止影响页面
        iframe.style.height = 0; // 防止影响页面
        iframe.src = fileDownloadUrlList[i];
        document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
        // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
        setTimeout(()=>{
          iframe.remove();
        }, 1000);
      }

      this.exportFolderShow = false;

    },

      uploadScreenshotForFolder(thumb){
          let data =new FormData()
          data.append('fileId',this.$store.state.currFolderId)
          data.append('thumbnail',thumb)
          this.$axios.post('/authorApi/z-geo-file/saveThumbnail',data)
              .then((res)=>{
                  if(res.data.status === 200){
                      this.$store.state.snackbarShow = true
                      this.$store.state.snackbarText = "保存成功"
                      this.$store.state.snackbarType = 'success'
                  }else{
                      this.$store.state.snackbarShow = true
                      this.$store.state.snackbarText = "保存失败"
                      this.$store.state.snackbarType = 'error'
                  }
              }).catch(()=>{
              this.$store.state.snackbarShow = true
              this.$store.state.snackbarText = "保存失败"
              this.$store.state.snackbarType = 'error'
          })
      },




    //获取样例列表
    getMarkerExampleList(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-geo-label-simple/getSimpleList",
        params:{
          curPageNum:1,
          maxResultNum:100
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.$store.state.exampleList = resultData.data.list;
        }
        else{
          // console.log(resultData.status + resultData.message);
        }
      }).catch(()=>{
        // console.log(err);
      });
    },

    //打开样例列表
    openExample(item){
      this.$axios({
        method:"get",
        url:"/authorApi/z-geo-label-simple/getSimpleById",
        params:{
          id:item.id
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.$store.state.globeOperationMarkerList.push(resultData.data.content)
          this.$emit('initMapMarker',this.$store.state.globeOperationMarkerList)
        }
        else{
          // console.log(resultData.status + resultData.message);
        }
      }).catch(()=>{
        // console.log(err);
      });

    },

    //从样例弹窗添加样例到数据列表(可能多个样例)
    addExampleToList(exampleId){
      let exampleIdList = JSON.parse(exampleId)

      let exampleContentList = [];
      let getContentNum = 0;
      for(let i=0;i<exampleIdList.length;i++){
        this.$axios({
          method:"get",
          url:"/authorApi/z-geo-label-simple/getSimpleById",
          params:{
            id:exampleIdList[i]
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          if(resultData.status === 200){
            getContentNum ++;
            exampleContentList.push(resultData.data.content)
          }
          else{
            // console.log(resultData.status + resultData.message);
          }
        }).catch(()=>{
       //   console.log(err);
        });
      }

      let temp = setInterval(()=>{
        if(getContentNum === exampleIdList.length){
          clearInterval(temp)

          //深度遍历补充长度和面积 属性
          for(let i=0;i<exampleContentList.length;i++){
            let getLengthAndAreaFile = exampleContentList[i].children
            this.chooseFolderGetLengthAndArea(getLengthAndAreaFile)
            //计算过长度和面积之后的导入文件
            exampleContentList[i].children = getLengthAndAreaFile
            this.$store.state.globeOperationMarkerList = this.$store.state.globeOperationMarkerList.concat(exampleContentList[i])
            this.$emit('initMapMarker',this.$store.state.globeOperationMarkerList)
            this.exampleDialogShow = false;
          }

        }
      },1000)


    },


    //'''''''''''''''''''新东西-2023年11月'''''''''''''''''''''''''

      //文件夹保存
      saveFolder(){
          if(this.$store.state.handleNodeOption === 'modify'){
              //通知修改弹窗
              this.$emit("openNotSavedDialog",)
          }else {
              if (this.$store.state.currFolderRole === 1) {
                  //先截屏在保存文件
                  html2canvas(this.$parent.$refs.globeMap, {
                      // width: 30, //截图宽度
                      // height: 50, //截图高度
                      backgroundColor: null, //画出来的图片有白色的边框,不要可设置背景为透明色（null）
                      useCORS: true, //支持图片跨域
                      scale: 1, //设置放大的倍数
                  }).then((canvas) => {
                      // 把生成的base64位图片上传到服务器,生成在线图片地址
                      let url = canvas.toDataURL("image/png"); // toDataURL: 图片格式转成 base64
                      //上传后台
                      let file = this.$utils.base64ToFile(url, "地球截图.jpg");
                      let paramData = new FormData();
                      paramData.append('multipartFile', file);
                      this.$axios.post('/managerApi/upoladFile/uploadPiture', paramData)
                          .then((resultData) => {
                              resultData = resultData.data;
                              if (resultData.status === 200) {
                                  this.uploadScreenshotForFolder(resultData.data.thumb)
                              } else {
                                  this.$store.state.snackbarShow = true
                                  this.$store.state.snackbarText = "保存失败"
                                  this.$store.state.snackbarType = 'error'
                              }
                          }).catch(() => {
                          this.$store.state.snackbarShow = true
                          this.$store.state.snackbarText = "保存失败"
                          this.$store.state.snackbarType = 'error'
                      })
                  })
              } else {
                  this.$axios({
                          method:"post",
                          url:"/authorApi/z-geo-file/fileSave",
                          data:{
                              fileId:this.$store.state.currFolderId,
                          }
                      }).then((res)=>{
                          if(res.data.status === 200){
                              this.$store.state.snackbarShow = true
                              this.$store.state.snackbarText = "保存成功"
                              this.$store.state.snackbarType = 'success'
                          }else{
                              this.$store.state.snackbarShow = true
                              this.$store.state.snackbarText = res.data.message
                              this.$store.state.snackbarType = 'error'
                          }
                  }).catch(()=>{
                      this.$store.state.snackbarShow = true
                      this.$store.state.snackbarText = '保存失败'
                      this.$store.state.snackbarType = 'error'
                  })
              }
            //埋点
            this.$utils.eventTracking("工作台_标记_保存")
          }
      },

      //另存为
      reSaveFolder(){
          if(this.$store.state.handleNodeOption === 'modify'){
              //通知修改弹窗
              this.$emit("openNotSavedDialog",)
          }else{

              this.resaveFolderShow = true
              // if(this.$store.state.currFolderRole ===3 && this.$store.state.currFolderTeamExport === 0){
              //     this.$store.state.snackbarShow=true
              //     this.$store.state.snackbarText = "暂无权限，请联系创建者"
              //     this.$store.state.snackbarType = 'error'
              // }else{
              //
              // }
          }

      },
      //数据导出
      exportFolder(){
          if(this.$store.state.handleNodeOption === 'modify'){
              //通知修改弹窗
              this.$emit("openNotSavedDialog",)
          }else {
              this.exportFolderShow = true
              // if (this.$store.state.currFolderRole === 3 && this.$store.state.currFolderTeamExport === 0) {
              //     this.$store.state.snackbarShow = true
              //     this.$store.state.snackbarText = "暂无权限，请联系创建者"
              //     this.$store.state.snackbarType = 'error'
              // } else {
              //
              // }
            //埋点
            this.$utils.eventTracking("工作台_标记_数据导出")
          }
      },
      //新建文件
      createFolder(){
          if(this.$store.state.handleNodeOption === 'modify'){
              //通知修改弹窗
              this.$emit("openNotSavedDialog")
          }else{
              this.createFolderShow = true
            //埋点
            this.$utils.eventTracking("工作台_标记_新建文件")
          }
      },

      // 导入图层
      openImportLayerDialog() {
        if (this.$store.state.handleNodeOption === 'modify') {
          //通知修改弹窗
          this.$emit("openNotSavedDialog")
        } else {
          this.importLayerDialogShow = true
          //埋点
          this.$utils.eventTracking("工作台_标记_图层导入")
        }
      },
      //打开文件
      chooseFolder(){
          if(this.$store.state.handleNodeOption === 'modify'){
              //通知修改弹窗
              this.$emit("openNotSavedDialog",)
          }else{
              this.chooseFolderShow = true
            //埋点
            this.$utils.eventTracking("工作台_标记_打开/导入文件")
          }
      },

      //打开团队文件弹窗接口
      openMemberList(){
          if(this.$store.state.handleNodeOption === 'modify'){
              //通知修改弹窗
              this.$emit("openNotSavedDialog",)
          }else{
              this.memberListDialogShow = true
          }

      },

      //解散了团队，打开新文件操作
      dissolveTeamOk(folderId){
          this.memberListDialogShow =false
          this.openFolderById(folderId)
      },

      //修改昵称成功，重新打开文件，刷新名字
      reNameOk(){
        this.openFolderById(this.$store.state.currFolderId)
      },
      //关闭邀请弹窗
      closeInviteDialog() {
          this.inviteMemberDialogShow = false
          this.inviteCode = ''
          this.$router.push({
              path:'/globe'
          })
      },
      //加入新团队，打开新文件
      inviteIntoTeamOk(folderId){
          this.inviteMemberDialogShow = false
          this.inviteCode = ''
          this.openFolderById(folderId)
          this.$router.push({
              path:'/globe'
          })
      },

      //监控ctrl+s
      handleEvent(event){
          if(event.keyCode === 83 &&event.ctrlKey){
              event.preventDefault()
              this.saveFolder()
          }
      },



  },



}
</script>

<style scoped>

</style>
